// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useQuery, type UseQueryResult } from 'react-query'

import { fetchTemplate, type RenderedTemplate } from '@/services/templates'

const queryKey = (templateId: string) =>
  ['GetRenderedTemplate', templateId] as const

export const useGetRenderedTemplate = (
  templateId?: string
): UseQueryResult<RenderedTemplate, Error> => {
  return useQuery(
    queryKey(templateId ?? ''),
    async () => {
      if (!templateId) throw new Error('No template ID provided')

      return fetchTemplate(templateId)
    },
    {
      enabled: Boolean(templateId),
    }
  )
}
